jQuery(document).ready(function () {
    jQuery(window).on('YoastSEO:ready', function () {
        new CarbonFieldsYoast();
    });

    // jQuery('select').chosen();
});
